import SEOLandingTemplate from './SEOLandingTemplate';

export default function RobotsTxtGeneratorPage() {
  return (
    <SEOLandingTemplate
      title="Robots.txt Generator"
      metaTitle="Free Robots.txt Generator | Sungresh"
      metaDescription="Generate a robots.txt file with allow/disallow rules and a sitemap reference, with basic syntax validation."
      h1="Free Robots.txt Generator"
      sub="Build a robots.txt file without hand-writing the syntax: set allow/disallow rules, reference your sitemap, and get basic validation before you use it."
      keywords="robots.txt generator, free robots.txt generator, create robots.txt file"
      ctaLink="/checker"
      ctaText="Generate Robots.txt Free"
      features={[
        { icon: '🤖', title: 'Visual Builder', desc: 'Set allow/disallow rules without writing syntax by hand' },
        { icon: '🗺️', title: 'Sitemap Reference', desc: 'Add your sitemap URL to the file' },
        { icon: '✅', title: 'Syntax Check', desc: 'Basic validation before you use the file' },
      ]}
      faqs={[
        { q: 'What is robots.txt for?', a: 'It tells well-behaved search engine crawlers which parts of your site they should or shouldn\'t bother crawling — useful for pointing crawl budget away from admin pages, cart pages, or filtered URL parameters that don\'t need indexing.' },
        { q: 'What should I typically disallow?', a: 'Common candidates are admin areas, cart/checkout pages, login pages, and URLs with tracking or filter parameters. Never disallow the folders serving your CSS, JavaScript, or images — blocking those can hurt how Google renders and understands your pages.' },
        { q: 'Where does robots.txt need to live?', a: 'At your domain root — yoursite.com/robots.txt — not in a subfolder. It won\'t be recognized anywhere else.' },
      ]}
    />
  );
}
